export default __webpack_public_path__ + "9b3af0a0ab225005b5b1a66656eb0a80.svg";